import PropTypes from 'prop-types'
import './styles/Header.css';
import React from "react";

const Header = ({ title }) => {
    return (
        <header className='header'>
            <span className= "header-icon">{title}</span>
        </header>
    )
}
Header.defaultProps = {
    title: 'Gradient',
}
Header.propTypes = {
    title: PropTypes.string.isRequired,
}

export default Header